<template>
    <div class="add-qwilr-data-source">
      <h3>Add Data Source</h3>
      <div class="form-group mb-4">
        <label for="data-source-name" class="form-label">Data Source Name</label>
        <input
          type="text"
          id="data-source-name"
          class="form-control"
          placeholder="Enter data source name"
          v-model="dataSourceName"
      />
      </div>
      <div class="form-group mb-4">
        <label for="provider" class="form-label">Provider</label>
        <select 
            id="provider"
            class="form-select shadow-none fw-semibold rounded-0"
            v-model="selectedProviderId"
            >
            <option value="">Select a provider</option>
            <option 
                v-for="(provider, index) in providers" 
                :key="index" 
                :value="provider.id"
            >
            {{ provider.name }}
            </option>
        </select>
      </div>
      <div class="form-group mb-4">
        <label for="connection-string" class="form-label">Connection String</label>
        <input
          type="text"
          id="connection-string"
          class="form-control"
          placeholder="Enter connection string"
          v-model="connectionString"
      />
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="addDataSource" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Add Data Source
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { AddQwilrDataSource } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import { Provider} from "@/core/constant/QwilrDataSourceProvider";

  export default{
    name:"AddQwilrDataSource",
    data(){
        return{
            dataSourceName:'',
            connectionString:'',
            isBusy:false,
            providers:[
                {id:Provider.MySql, name:'MySql'}
            ],
            selectedProviderId:0
        }
    },
    methods:{
        async addDataSource(){
            this.isBusy=true;
            setTimeout(async () => {
              if (!this.validateFields()){
                this.isBusy=false;
                return;
              } 

            const toast = useToast();
            const payload = 
            { 
              dataSourceName:this.dataSourceName,
              provider:this.selectedProviderId, 
              connectionString:this.connectionString
            };
        
            await AddQwilrDataSource(payload)
                    .then(response => {
                    if (response.status === 200) {
                        toast.success('Data source added successfully!', {
                        timeout: 2000
                        })
                        this.isBusy=false;
                        this.$emit('dataSourceAdded'); // Emit the event to notify the parent component
                        this.$emit('close'); // Close the lightbox after adding data stream
                    }
                    })
                    .catch(ex => {
                        this.isBusy=false;
                        const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                        console.log(ex);
                        toast.error(`Failed to add data source : ${errorMessage}`, {timeout: 2000,});
                    })
            },500);
        },
        validateFields() {
          const toast = useToast();

          if (this.dataSourceName.trim() === '') {
            toast.error('Data source name is required!', { timeout: 3000 });
            return false; 
          }

          if (this.selectedProviderId<=0) {
            toast.error('Provider name is required!', { timeout: 3000 });
            return false; 
          }

          if (this.connectionString.trim() === '') {
            toast.error('Connection string is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    }
  }
 </script>
  
  <style scoped>
  .add-qwilr-data-source {
    width: 600px;
    height: 500px;
    padding: 40px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  